import { Minus, MoonStar, Plus, Sun } from "lucide-react";
import { MAX_FONT_SCALE, MIN_FONT_SCALE } from "../lib/useNightPaper";

export function ReaderTypographyControls({ fontScale, setFontScale, night, setNight, iconSize = 16 }: {
  fontScale: number;
  setFontScale: (updater: (value: number) => number) => void;
  night: boolean;
  setNight: (updater: (value: boolean) => boolean) => void;
  iconSize?: number;
}) {
  return <>
    {/* Границы кегля общие с хранилищем: сохранённое значение чинится по ним же,
        иначе руками поправленный localStorage пережил бы любой предел. */}
    <button aria-label="Уменьшить шрифт" onClick={() => setFontScale((value) => Math.max(MIN_FONT_SCALE, value - .1))}><Minus size={iconSize} /></button>
    <span>Аа</span>
    <button aria-label="Увеличить шрифт" onClick={() => setFontScale((value) => Math.min(MAX_FONT_SCALE, value + .1))}><Plus size={iconSize} /></button>
    <button
      aria-pressed={night}
      aria-label={night ? "Включить дневную бумагу" : "Включить ночную бумагу"}
      title={night ? "Дневная бумага" : "Ночная бумага"}
      onClick={() => setNight((value) => !value)}
    >{night ? <Sun size={iconSize} /> : <MoonStar size={iconSize} />}</button>
  </>;
}
